export default __webpack_public_path__ + "static/char-page-pic-02-f9836bd06ad071cd13201566600680da.png";